"use strict";

var filterPP = document.getElementById("blog-filter-pp");
var filterFashion = document.getElementById("blog-filter-fashion");
var filterBeauty = document.getElementById("blog-filter-beauty");
var filterCulture = document.getElementById("blog-filter-culture");
var filterLiving = document.getElementById("blog-filter-living");
var filterWtw = document.getElementById("blog-filter-wtw");
var newsArticleArray = Array.apply(null, document.getElementsByClassName("newsArticle"));
var blogPostArray = Array.apply(null, document.getElementsByClassName("article"));
var eventsArray = [{
  DomElement: filterPP,
  action: "Clicked Category Filter",
  label: "Powerful Profile"
}, {
  DomElement: filterFashion,
  action: "Clicked Category Filter",
  label: "Fashion"
}, {
  DomElement: filterBeauty,
  action: "Clicked Category Filter",
  label: "Beauty"
}, {
  DomElement: filterCulture,
  action: "Clicked Category Filter",
  label: "Culture"
}, {
  DomElement: filterLiving,
  action: "Clicked Category Filter",
  label: "Living"
}, {
  DomElement: filterWtw,
  action: "Clicked Category Filter",
  label: "What To Wear"
}];
newsArticleArray.forEach(function (e) {
  eventsArray.push({
    DomElement: e,
    action: "Clicked on News Article",
    label: "In The News"
  });
});
blogPostArray.forEach(function (e) {
  eventsArray.push({
    DomElement: e,
    action: "Clicked on an Article",
    label: "Main List"
  });
});
eventsArray.forEach(function (e) {
  e.DomElement.addEventListener("click", function () {
    sendEvent(GaEventPage, e.action, e.label);
  }, {
    passive: true
  });
});